var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "63px",
    viewBox: "0 0 240 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_header") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.135912285 0.111102468 40.3721203 0.111102468 40.3721203 40.7027469 0.135912285 40.7027469"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 36.6621943 0 36.6621943 58.8460068 0 58.8460068"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "-1.98951966e-13 58.8042703 201 58.8042703 201 0.845070423 -1.98951966e-13 0.845070423"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "0.135912285 0.109827522 40.3721203 0.109827522 40.3721203 40.2356662 0.135912285 40.2356662"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-9",
    points: "0 0 36.6621943 0 36.6621943 58.1707247 0 58.1707247"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-11",
    points: "-1.98951966e-13 58.1294672 201 58.1294672 201 0.835372893 -1.98951966e-13 0.835372893"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_header",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(20.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.048029, 17.953019)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6621575,26.153608 L9.82059227,20.5497829 L30.4781087,11.4800282 C28.1190454,8.28388671 24.791514,6.68556707 20.4940301,6.68556707 C16.8364179,6.68556707 13.7429619,7.98174407 11.2146517,10.5755914 C8.68584668,13.1689409 7.42193903,16.3158038 7.42193903,20.0146868 C7.42193903,23.955483 8.6759492,27.2526706 11.1844644,29.9062495 C13.6924848,32.5603262 16.8962977,33.8868668 20.7939236,33.8868668 C27.0496231,33.8868668 31.3673969,30.2984874 33.7457603,23.120733 L40.3721203,24.6588233 C36.5343741,35.3547723 29.9881837,40.7027469 20.7340439,40.7027469 C15.1573112,40.7027469 10.3298174,38.7226424 6.25255228,34.7619356 C2.17528716,30.8012289 0.135912285,26.0261805 0.135912285,20.4372883 C0.135912285,14.7274394 2.09462273,9.91207218 6.01253849,5.9916843 C9.92995938,2.07129641 14.7376582,0.111102468 20.435635,0.111102468 C29.0701928,0.111102468 35.5866908,4.75723001 39.9846341,14.0494851 L12.6621575,26.153608 Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "t",
    transform: "translate(45.871369, 7.605634)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8480408,43.6997764 L21.8480408,51.1216719 L21.5844341,51.1216719 C17.7899126,51.1216719 13.9953911,51.1360098 10.2018796,51.1165512 C7.97990801,51.1063099 5.97710361,50.4119474 4.25406563,48.9771363 C3.06531082,47.9857751 2.25833114,46.6861497 1.58668972,45.3045936 C0.736810675,43.5515097 0.235749078,41.6458627 0.112108567,39.6964386 C0.0414094708,38.6538707 0.011109858,37.6061821 0.00504993546,36.5615659 C-0.00168331182,24.5054664 -0.00168331182,12.4497082 0.00504993546,0.394291397 L0.00504993546,0 L7.15575855,0 L7.15575855,10.0590392 L22.5186722,10.0590392 L22.5186722,17.4020764 L7.15373857,17.4020764 L7.15373857,17.7799817 C7.15373857,24.8751786 7.16383844,31.9693513 7.14767865,39.0635241 C7.14767865,41.0401017 8.4970214,42.9357728 10.3048983,43.58917 C11.0492588,43.8585171 11.8037191,43.8779756 12.5763593,43.8615895 C15.6063205,43.7974105 18.6386385,43.740059 21.673313,43.6895351 C21.7268423,43.6905592 21.7813816,43.6956799 21.8480408,43.6997764 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(72.883588, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56045332,1.07974324 L7.56045332,22.5183297 C9.26213371,21.2970006 11.0618358,20.2591549 12.961386,19.4030883 C14.8591097,18.548158 17.0515072,18.1209768 19.540405,18.1209768 C23.9903449,18.1209768 27.869202,19.3275364 31.1757588,21.7395194 C34.4804891,24.1532065 36.1346807,27.4655647 36.1346807,31.6800022 L36.1346807,58.7980531 L28.4755969,58.7980531 L28.4755969,35.4360153 C28.4755969,32.2605596 27.5580898,29.7559828 25.7261198,27.9234211 C23.8923232,26.0914274 21.601904,25.1751466 18.8524269,25.1751466 C15.578747,25.1751466 13.108114,25.9692945 11.4393105,27.5570224 C9.76989809,29.1458863 8.64051808,30.8864223 8.05177929,32.7791984 C7.85512714,33.3285125 7.72361981,33.8943003 7.65847498,34.4742896 C7.59333015,35.054847 7.56045332,35.6189307 7.56045332,36.1688128 L7.56045332,58.7980531 L0,58.7980531 L0,1.07974324 L7.56045332,1.07974324 Z",
    id: "Fill-6",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#FFFFFF",
    mask: "url(#mask-6)",
    points: "114.434075 58.7156998 122.744173 58.7156998 122.744173 17.9892288 114.434075 17.9892288"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    mask: "url(#mask-6)",
    cx: 118.622951,
    cy: 5.55555556,
    rx: 4.39344262,
    ry: 4.44444444
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.486221,17.953019 C152.747852,18.0164271 154.384421,18.6317205 155.397588,19.7994863 C156.40854,20.9684263 156.915124,22.277099 156.915124,23.729027 C156.915124,24.0454804 156.900175,24.3443204 156.870832,24.6284826 C156.840382,24.9126448 156.766194,25.212659 156.647714,25.5279382 C156.468887,26.3493079 156.170474,27.1536513 155.754688,27.9427299 C155.337795,28.7323956 154.831211,29.442214 154.236599,30.0733594 L137.093042,52.1358546 L157.45105,52.1358546 L157.45105,58.7637621 L133.967727,58.7637621 C132.538775,58.8271702 131.288649,58.4009269 130.217349,57.4850321 C129.14605,56.5703116 128.610124,55.4183978 128.610124,54.0287037 C128.610124,53.5883697 128.66881,53.1298352 128.78895,52.6560358 C128.906876,52.1828235 129.086257,51.6949335 129.324323,51.1882558 C129.50315,50.8095685 129.726268,50.4308813 129.994231,50.052194 C130.262195,49.6735068 130.543445,49.2948195 130.842966,48.9155452 L148.611032,25.243776 L130.217349,25.243776 L130.217349,17.953019 L150.486221,17.953019 Z",
    id: "Fill-11",
    fill: "#FFFFFF",
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "o",
    mask: "url(#mask-6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(160.132780, 17.746479)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.55115,59.1549058 C169.263503,59.1377239 160.108241,49.8423323 160.132829,38.4258388 C160.157418,26.9852907 169.340659,17.70794 180.600326,17.7465993 C191.886276,17.7852585 201.009319,27.0480045 200.999993,38.4567662 C200.990666,49.8913006 191.821838,59.1720876 180.55115,59.1549058 Z M194.274716,38.4507525 C194.274716,30.7421066 188.107335,24.479315 180.520626,24.4861877 C172.933917,24.4930605 166.79706,30.7326565 166.784342,38.4318525 C166.771624,46.1310484 172.929678,52.4084445 180.519779,52.4153173 C188.109879,52.42219 194.273868,46.1619757 194.274716,38.4507525 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(20.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.048029, 17.747001)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6621575,25.8534847 L9.82059227,20.3139657 L30.4781087,11.3482902 C28.1190454,8.18882572 24.791514,6.60884745 20.4940301,6.60884745 C16.8364179,6.60884745 13.7429619,7.89015029 11.2146517,10.4542321 C8.68584668,13.0178219 7.42193903,16.1285733 7.42193903,19.78501 C7.42193903,23.680584 8.6759492,26.939935 11.1844644,29.563063 C13.6924848,32.1866831 16.8962977,33.4980011 20.7939236,33.4980011 C27.0496231,33.4980011 31.3673969,29.9507998 33.7457603,22.8554132 L40.3721203,24.3758532 C36.5343741,34.9490618 29.9881837,40.2356662 20.7340439,40.2356662 C15.1573112,40.2356662 10.3298174,38.2782842 6.25255228,34.3630282 C2.17528716,30.4477721 0.135912285,25.7275194 0.135912285,20.202762 C0.135912285,14.558436 2.09462273,9.79832709 6.01253849,5.92292726 C9.92995938,2.04752744 14.7376582,0.109827522 20.435635,0.109827522 C29.0701928,0.109827522 35.5866908,4.70263885 39.9846341,13.8882615 L12.6621575,25.8534847 Z",
    id: "Fill-1",
    fill: "#3BC9B0",
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "t",
    transform: "translate(45.871369, 7.518356)",
    fill: "#1F718F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8480408,43.1983036 L21.8480408,50.5350297 L21.5844341,50.5350297 C17.7899126,50.5350297 13.9953911,50.5492031 10.2018796,50.5299678 C7.97990801,50.519844 5.97710361,49.8334496 4.25406563,48.4151036 C3.06531082,47.4351187 2.25833114,46.150407 1.58668972,44.7847048 C0.736810675,43.0517383 0.235749078,41.1679594 0.112108567,39.2409057 C0.0414094708,38.2103017 0.011109858,37.1746357 0.00504993546,36.142007 C-0.00168331182,24.2242561 -0.00168331182,12.3068427 0.00504993546,0.389766742 L0.00504993546,0 L7.15575855,0 L7.15575855,9.94360763 L22.5186722,9.94360763 L22.5186722,17.2023805 L7.15373857,17.2023805 L7.15373857,17.5759491 C7.15373857,24.5897257 7.16383844,31.6024899 7.14767865,38.6152541 C7.14767865,40.5691497 8.4970214,42.4430672 10.3048983,43.0889664 C11.0492588,43.3552226 11.8037191,43.3744579 12.5763593,43.3582598 C15.6063205,43.2948172 18.6386385,43.2381239 21.673313,43.1881798 C21.7268423,43.1891921 21.7813816,43.194254 21.8480408,43.1983036 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(72.883588, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56045332,1.06735275 L7.56045332,22.2599226 C9.26213371,21.0526088 11.0618358,20.0266727 12.961386,19.18043 C14.8591097,18.3353103 17.0515072,17.9130312 19.540405,17.9130312 C23.9903449,17.9130312 27.869202,19.105745 31.1757588,21.4900495 C34.4804891,23.8760386 36.1346807,27.1503861 36.1346807,31.3164612 L36.1346807,58.1233213 L28.4755969,58.1233213 L28.4755969,35.0293725 C28.4755969,31.8903565 27.5580898,29.4145207 25.7261198,27.6029884 C23.8923232,25.7920176 21.601904,24.8862514 18.8524269,24.8862514 C15.578747,24.8862514 13.108114,25.6712862 11.4393105,27.2407942 C9.76989809,28.8114253 8.64051808,30.531988 8.05177929,32.4030437 C7.85512714,32.9460542 7.72361981,33.5053493 7.65847498,34.078683 C7.59333015,34.6525783 7.56045332,35.2101888 7.56045332,35.7537608 L7.56045332,58.1233213 L0,58.1233213 L0,1.06735275 L7.56045332,1.06735275 Z",
    id: "Fill-6",
    fill: "#1F718F",
    mask: "url(#mask-10)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#1F718F",
    mask: "url(#mask-12)",
    points: "114.434075 58.0419131 122.744173 58.0419131 122.744173 17.7827951 114.434075 17.7827951"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3BC9B0",
    mask: "url(#mask-12)",
    cx: 118.622951,
    cy: 5.49180328,
    r: 4.39344262
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.486221,17.7470008 C152.747852,17.8096812 154.384421,18.4179139 155.397588,19.5722791 C156.40854,20.727805 156.915124,22.0214601 156.915124,23.4567267 C156.915124,23.7695486 156.900175,24.0649593 156.870832,24.3458607 C156.840382,24.626762 156.766194,24.9233334 156.647714,25.2349946 C156.468887,26.0469388 156.170474,26.8420521 155.754688,27.6220756 C155.337795,28.4026795 154.831211,29.1043525 154.236599,29.7282553 L137.093042,51.5375743 L157.45105,51.5375743 L157.45105,58.0894238 L133.967727,58.0894238 C132.538775,58.1521043 131.288649,57.7307523 130.217349,56.8253678 C129.14605,55.9211441 128.610124,54.782449 128.610124,53.4087022 C128.610124,52.9734212 128.66881,52.5201486 128.78895,52.0517862 C128.906876,51.5840042 129.086257,51.1017129 129.324323,50.6008496 C129.50315,50.2265079 129.726268,49.8521663 129.994231,49.4778246 C130.262195,49.1034829 130.543445,48.7291413 130.842966,48.3542193 L148.611032,24.9540933 L130.217349,24.9540933 L130.217349,17.7470008 L150.486221,17.7470008 Z",
    id: "Fill-11",
    fill: "#1F718F",
    mask: "url(#mask-12)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "o",
    mask: "url(#mask-12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(160.132780, 17.542831)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.55115,58.476079 C169.263503,58.4590943 160.108241,49.2703711 160.132829,37.9848865 C160.157418,26.6756234 169.340659,17.5047342 180.600326,17.5429498 C191.886276,17.5811653 201.009319,26.7376176 200.999993,38.015459 C200.990666,49.3187775 191.821838,58.4930637 180.55115,58.476079 Z M194.274716,38.0095144 C194.274716,30.3893283 188.107335,24.1984048 180.520626,24.2051987 C172.933917,24.2119926 166.79706,30.3799867 166.784342,37.9908312 C166.771624,45.6016757 172.929678,51.8070362 180.519779,51.81383 C188.109879,51.8206239 194.273868,45.6322481 194.274716,38.0095144 Z",
    id: "Shape",
    fill: "#1F718F",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.92660a05d691e6b4162d61159c314718.svg";
export { ForwardRef as ReactComponent };